import { render, staticRenderFns } from "./addVerificationList.vue?vue&type=template&id=f534d2d0&scoped=true&"
import script from "./addVerificationList.vue?vue&type=script&lang=js&"
export * from "./addVerificationList.vue?vue&type=script&lang=js&"
import style0 from "./addVerificationList.vue?vue&type=style&index=0&id=f534d2d0&prod&lang=scss&scoped=true&"
import style1 from "./addVerificationList.vue?vue&type=style&index=1&id=f534d2d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f534d2d0",
  null
  
)

export default component.exports